import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'ngx-messaging-away-modal',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NgxMessagingAwayModalComponent {
  constructor(private dialogRef: MatDialogRef<NgxMessagingAwayModalComponent>) {}
  close(): void {
    this.dialogRef.close();
  }
}
